/**
 * API Configuration utility
 * Uses same-origin for all deployed environments (Azure, custom domains, preview)
 * Only uses env variable for localhost development
 */
const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Only use env variable for localhost development
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return process.env.REACT_APP_BACKEND_URL || '';
    }
    
    // All deployed environments: use same origin (works with any custom domain)
    return '';
  }
  
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_URL = getApiUrl();

export default API_URL;
